import kish from '../assets/png/kish.jpg'
import ResumeKinuthiaWachira from '../assets/pdf/ResumeKinuthiaWachira-Ai-Automation.pdf'

export const headerData = {
    name: 'Ian Kinuthia Wachira',
    title: "Automation Engineer | IT Support Specialist",
    desciption:"Automation-focused engineer with hands-on experience building workflows in n8n, integrating APIs with Claude Code and ChatGPT, and managing digital operations in Notion and Google Workspace.",
    image: kish,
    resumePdf: ResumeKinuthiaWachira
}
